import { render, staticRenderFns } from "./IconLearningRequest.vue?vue&type=template&id=d5746a68"
import script from "./IconLearningRequest.vue?vue&type=script&lang=js"
export * from "./IconLearningRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports